import React from 'react'
import { ClipBoard, Check, WhatsApp, Phone } from '../../../assets/icons'
import { Text1Bold, SubTitle } from '../text'
import useContactCopy from '../../../hooks/useContactCopy'
import { CardContainer, ContactRow, ContactButton } from './styled'
import theme from '../../../styles/theme'

const CONTACT_ICONS = {
	whatsapp: WhatsApp,
	phone: Phone
}

const DEFAULT_CONTACTS = [
	{ type: 'whatsapp', value: '+54 9 11 4493-2017' },
	{ type: 'phone', value: '0800-666-6587' }
]

const ContactHelpCard = ({ title, description, contacts = DEFAULT_CONTACTS }) => {
	const { copiedIndex, handleContactClick } = useContactCopy()

	return (
		<CardContainer>
			{title && (
				<Text1Bold
					size="18px"
					align="center"
					color={theme.colors.text.primaryText}
					style={{ textAlign: 'center' }}
				>
					{title}
				</Text1Bold>
			)}
			{description && (
				<SubTitle
					size="16px"
					lineHeight="22px"
					fontWeight={400}
					color={theme.colors.text.secondaryText}
					style={{ textAlign: 'center', whiteSpace: 'pre-line' }}
				>
					{description}
				</SubTitle>
			)}
			<ContactRow>
				{contacts.map((contact, index) => {
					const Icon = CONTACT_ICONS[contact.type] || Phone
					const isCopied = copiedIndex === index
					return (
						<ContactButton
							key={contact.value}
							type="button"
							label={contact.value}
							$variant="secondary"
							iconLeft={<Icon size={20} color="currentColor" />}
							iconRight={
								contact.type === 'whatsapp' ? null : isCopied ? (
									<Check size={20} color="currentColor" />
								) : (
									<ClipBoard size={20} color="currentColor" />
								)
							}
							onClick={() => handleContactClick(contact, index)}
						/>
					)
				})}
			</ContactRow>
		</CardContainer>
	)
}

export default ContactHelpCard
